/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable no-promise-executor-return */
/* eslint-disable no-empty */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
// src/babylon-cache-bootstrap.ts

// Side-effect module: registers SW (if CSS flag is true) and patches Babylon loaders to use a custom cache.
// Imports: none. Exports: none.

export {}; // mark this file as a module for TS

// ------------------------------
// Utilities / gates ------------
// ------------------------------
// const INSTALL_FLAG = Symbol.for('babylon-cache-bootstrap/installed');

export function cssVarTrue(name: string): boolean {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return false;
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim().toLowerCase();
    return v === 'true' || v === '1' || v === 'yes' || v === 'on';
  } catch { return false; }
}

const bIsCacheDisabled = cssVarTrue('--disable-mindsales-cache');

function log(...args: any[]) {
  // minimal logging; flip to false to silence
  if (true) console.log('[babylon-cache]', ...args);
}

// ---------------------------------------------------------------------
// Cache + Metadata implementation (Cache Storage + IndexedDB)
// ----------------------------------------------------------------------
const CACHE_NAME = 'mindsales-assets-v1'; // keep in sync with sw.js
const ASSET_EXT = /\.(bin|gltf|glb|ktx2|png|jpe?g|webp|avif|json|svg)$/i;

function stripNumericQuery(urlStr: string): string {
  try {
    const u = new URL(urlStr, typeof window !== 'undefined' ? window.location.href : 'http://localhost/');
    if (ASSET_EXT.test(u.pathname) && /^\?\d+$/.test(u.search)) u.search = '';
    return u.href;
  } catch { return urlStr; }
}

// --------------------------------------------------------------------
// ---- IndexedDB meta store ---------------------------------------
// --------------------------------------------------------------------
type Meta = {
  url: string;
  size: number;
  lastAccess: number;
  pinned?: boolean;
  ttlMs?: number;
};

const DB_NAME = 'mindsales';
const STORE = 'entries';
let dbPromise: Promise<IDBDatabase> | null = null;

function openDB(): Promise<IDBDatabase> {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const store = db.createObjectStore(STORE, { keyPath: 'url' });
        store.createIndex('lastAccess', 'lastAccess');
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}
async function readMeta(url: string): Promise<Meta | undefined> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly');
    const req = tx.objectStore(STORE).get(url);
    req.onsuccess = () => resolve(req.result as Meta | undefined);
    req.onerror = () => reject(req.error);
  });
}
export async function writeMeta(meta: Meta): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).put(meta);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}
async function deleteMeta(url: string): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).delete(url);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}
async function listLRUCandidates(limit: number): Promise<Meta[]> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly');
    const idx = tx.objectStore(STORE).index('lastAccess');
    const out: Meta[] = [];
    // eslint-disable-next-line consistent-return
    idx.openCursor().onsuccess = (ev) => {
      // @ts-ignore
      const cursor: IDBCursorWithValue | null = ev.target.result;
      if (!cursor || out.length >= limit) return resolve(out);
      const m = cursor.value as Meta;
      if (!m.pinned) out.push(m);
      cursor.continue();

    };
    tx.onerror = () => reject(tx.error);
  });
}
async function evictIfNeeded(maxBytes = 1024 * 1024 * 1024) {
  try {
    // Use StorageManager estimate as a heuristic
    // @ts-ignore
    const est = await navigator.storage?.estimate?.();
    const used = est?.usage ?? 0;
    if (used < maxBytes) return;

    const cache = await caches.open(CACHE_NAME);
    const batch = await listLRUCandidates(10);
    for (const m of batch) {
      await cache.delete(m.url, { ignoreSearch: true });
      await deleteMeta(m.url);
      log('evicted', m.url);
    }
  } catch { /* ignore */ }
}

// -------------------------------------------------------------------
// ---- Public-ish cache function the Babylon patch will use ----
// -------------------------------------------------------------------
type GetAssetOpts = {
  as?: 'arrayBuffer' | 'text';
  ttlMs?: number;
  pin?: boolean;
  integrityHash?: string; // optional SHA-256 hex
};

async function hashArrayBuffer(buf: ArrayBuffer): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', buf);
  const bytes = Array.from(new Uint8Array(digest));
  return bytes.map((b) => b.toString(16).padStart(2, '0')).join('');
}

async function getAsset(urlIn: string, opts: GetAssetOpts = {}) {
  const url = stripNumericQuery(urlIn);
  const as = opts.as ?? (/\.(?:bin|glb|ktx2|png|jpe?g|webp|avif)$/i.test(url) ? 'arrayBuffer' : 'text');

  let res : Response | undefined;
  let cache: Cache | undefined;
  const now = Date.now();
  let meta : Meta | undefined;
  let ttl : number = 0;
  if (!bIsCacheDisabled) {
    cache = await caches.open(CACHE_NAME);

    meta = await readMeta(url);
    ttl = opts.ttlMs ?? meta?.ttlMs ?? (
      /\.(?:gltf|json|svg)$/i.test(url) ? 0 : 365 * 24 * 3600 * 1000 // text-ish revalidates always; binaries ~1y
    );

    // Try cache
    let res = await cache.match(url, { ignoreSearch: true });
    if (res && ttl > 0 && meta && meta.lastAccess + ttl < now) {
      // expired -> force network refresh
      res = undefined;
    }
  }

  // Network fetch if needed
  if (!res) {
    const cacheMode: RequestCache = /\.(?:gltf|json|svg)$/i.test(url) ? 'no-cache' : 'default';
    const net = await fetch(url, { credentials: 'same-origin', cache: cacheMode });
    if (!net.ok) throw new Error(`HTTP ${net.status} for ${url}`);
    res = net.clone();
    if (!bIsCacheDisabled) await cache?.put(url, net);
  }

  // Materialize body
  const body = as === 'arrayBuffer' ? await res.arrayBuffer() : await res.text();

  if (!bIsCacheDisabled) {
    // Optional integrity check
    if (opts.integrityHash && as === 'arrayBuffer') {
      const h = await hashArrayBuffer(body as ArrayBuffer);
      if (h !== opts.integrityHash) {
        await cache?.delete(url);
        await deleteMeta(url);
        throw new Error(`Integrity mismatch for ${url}`);
      }
    }

    const sizeHdr = res.headers.get('content-length');
    const size = sizeHdr ? Number(sizeHdr) : (as === 'arrayBuffer' ? (body as ArrayBuffer).byteLength : (body as string).length);

    await writeMeta({
      url,
      size,
      lastAccess: now,
      pinned: opts.pin ?? meta?.pinned ?? false,
      ttlMs: ttl,
    });

    evictIfNeeded().catch(() => {});
  }
  return body;
}

// -------------------------------------------------------------------
// ---- Global XHR normalizer (safe regardless of Babylon build) ----
// ---- "In god we trust, but we verify" ----------------------------
// -------------------------------------------------------------------
(function normalizeXHR() {
  const XHR = (window as any).XMLHttpRequest;
  if (!XHR?.prototype?.open || !XHR?.prototype?.send) return;

  const origOpen = XHR.prototype.open;
  const origSend = XHR.prototype.send;

  XHR.prototype.open = function (method: string, url: string, ...rest: any[]) {
    const ASSET_EXT = /\.(bin|gltf|glb|ktx2|png|jpe?g|webp|avif|json|svg)$/i;
    function stripNumericQuery(u: string) {
      try {
        const x = new URL(u, window.location.href);
        if (ASSET_EXT.test(x.pathname) && /^\?\d+$/.test(x.search)) x.search = '';
        return x.href;
      } catch { return u; }
    }
    (this as any).__isGetLike = /^(GET|HEAD)$/i.test(method);
    (this as any).__normUrl = stripNumericQuery(url);
    return origOpen.call(this, method, (this as any).__normUrl, ...rest);
  };

  XHR.prototype.send = function (body?: any) {
    try {
      if ((this as any).__isGetLike) {
        const url: string = (this as any).__normUrl || '';
        if (/\.(?:gltf|json|svg)$/i.test(url)) {
          try { this.setRequestHeader('Cache-Control', 'no-cache'); } catch {}
        }
      }
    } catch {}
    return origSend.call(this, body);
  };
}());

// -------------------------------------------------------------------------
// ---- Patch Babylon loaders (UMD variants) or fall back to WebRequest ----
// ---- We really don't trust this 'peasant' and we surely verify ----------
// -------------------------------------------------------------------------
(function patchBabylonAny() {
  const FLAG = Symbol.for('babylon-cache-bootstrap/patched');

  function patchWith(B: any): boolean {
    const FileTools = B?.FileTools;
    const Tools = B?.Tools;
    const WebReq = B?.WebRequest;

    // Stop timestamping if present
    try {
      if (FileTools && typeof FileTools.AppendTimestampToUrl === 'function') {
        FileTools.AppendTimestampToUrl = (u: string) => u;
      }
    } catch {}

    let patched = false;

    // Callback style
    if (FileTools && typeof FileTools.RequestFile === 'function') {
      FileTools.RequestFile = function (
        url: string,
        onSuccess: (data: string | ArrayBuffer) => void,
        onProgress?: any,
        offlineProvider?: any,
        useArrayBuffer?: boolean,
        onError?: (req?: any, ex?: any) => void,
      ) {
        getAsset(url, { as: useArrayBuffer ? 'arrayBuffer' : 'text' })
          .then((data) => onSuccess(data as any))
          .catch((e) => onError?.(undefined, e));
      };
      patched = true;
    }

    // Promise style
    const hookLFA = (host: any) => {
      if (host && typeof host.LoadFileAsync === 'function') {
        host.LoadFileAsync = function (url: string, useArrayBuffer?: boolean) {
          return getAsset(url, { as: useArrayBuffer ? 'arrayBuffer' : 'text' });
        };
        patched = true;
      }
    };
    hookLFA(FileTools);
    hookLFA(Tools);

    // Older Tools.LoadFile
    if (Tools && typeof Tools.LoadFile === 'function') {
      Tools.LoadFile = function (
        url: string,
        onSuccess: (data: any) => void,
        onProgress?: any,
        useArrayBuffer?: boolean,
        onError?: (req?: any, ex?: any) => void,
      ) {
        getAsset(url, { as: useArrayBuffer ? 'arrayBuffer' : 'text' })
          .then(onSuccess)
          .catch((e) => onError?.(undefined, e));
      };
      patched = true;
    }

    // WebRequest fallback (Babylon's XHR wrapper)
    if (!patched && WebReq && WebReq.prototype && typeof WebReq.prototype.open === 'function') {
      const origOpen = WebReq.prototype.open;
      const origSend = WebReq.prototype.send;

      WebReq.prototype.open = function (method: string, url: string) {
        // normalize ?123 → "" to kill cache-busters
        const norm = (function stripNumericQuery(urlStr: string): string {
          try {
            const u = new URL(urlStr, window.location.href);
            if (/\.(bin|gltf|glb|ktx2|png|jpe?g|webp|avif|json|svg)$/i.test(u.pathname) && /^\?\d+$/.test(u.search)) {
              u.search = '';
            }
            return u.href;
          } catch { return urlStr; }
        }(url));

        (this as any).__method = method.toUpperCase();
        (this as any).__normUrl = norm;
        return origOpen.call(this, method, norm);
      };

      WebReq.prototype.send = function (body?: any) {
        try {
          const method = (this as any).__method || 'GET';
          const url = (this as any).__normUrl || '';

          // read policy for GET/HEAD only
          if (method === 'GET' || method === 'HEAD') {
            const as = /\.(?:bin|glb|ktx2|png|jpe?g|webp|avif)$/i.test(url) ? 'arrayBuffer' : 'text';

            // Use our cache pipeline to fetch the bytes,
            // then fall back to native send if anything throws.
            return getAsset(url, { as })
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              .then((_data) => {
                // We can't easily shove the data back into WebRequest's XHR;
                // but by the time Babylon requests again, Cache Storage + SW will serve it.
                // As a compromise, proceed with original send (fast path will be cached).
                return origSend.call(this, body);
              })
              .catch(() => origSend.call(this, body));
          }
        } catch { /* ignore */ }
        return origSend.call(this, body);
      };

      patched = true;
    }

    if (patched) {
      (window as any)[FLAG] = true;
      console.log('[babylon-cache] Babylon loaders patched -> custom cache');
    }
    return patched;
  }

  function tryPatch(): boolean {
    const B = (window as any).BABYLON;
    if (!B) return false;
    return patchWith(B);
  }

  if (tryPatch()) return;

  // Poll up to 30s (50ms interval)
  let attempts = 0;
  const id = setInterval(() => {
    if (tryPatch()) { clearInterval(id); return; }
    if (++attempts > 600) {
      clearInterval(id);
      console.warn('[babylon-cache] BABYLON loaders not detected within timeout; patch skipped.');
    }
  }, 50);

  // Also try after window load (some libs attach late)
  window.addEventListener('load', () => tryPatch());
}());

// -------------------------------------------------------------------------------------------------
// -- Cache deletion ------------------------------------------------------------------------------
// -- When everything fails, let's flush the ocean , Noah's Ark included, we really want a reset --
// --------------------------------------------------------------------------------------------------
export async function clearAllCaches(): Promise<void> {
  console.log('[babylon-cache] Clearing all caches…');

  // 1️) Delete our Cache Storage (mindsales-assets-v1)
  const cacheNames = await caches.keys();
  for (const name of cacheNames) {
    if (name.startsWith('mindsales-assets-')) {
      await caches.delete(name);
      console.log(`[babylon-cache] Deleted cache: ${name}`);
    }
  }

  // 2️) Delete our IndexedDB (DB_NAME)
  try {
    await new Promise<void>((resolve, reject) => {
      const req = indexedDB.deleteDatabase(DB_NAME);
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
      req.onblocked = () => reject(new Error('Delete blocked'));
    });
    console.log(`[babylon-cache] Deleted IndexedDB ${DB_NAME}`);
  } catch (err) {
    console.warn(`[babylon-cache] Could not delete IndexedDB(${DB_NAME}):`, err);
  }

  // 3️) Clear Babylon’s internal caches (if Babylon is loaded)
  try {
    const B = (window as any).BABYLON;
    if (B) {
      // Texture cache
      B.BaseTexture?.WhenAllReady && B.EngineStore?.Instances?.forEach((engine: any) => {
        engine?.dispose?.();
      });

      // FileTools offline provider (legacy cache)
      if (B.FilesInput?.FilesToLoad) B.FilesInput.FilesToLoad = {};

      // WebGL buffers / compiled shaders
      if (B.EngineStore?.Instances) {
        for (const eng of B.EngineStore.Instances) {
          eng?.dispose?.();
        }
      }

      console.log('[babylon-cache] Babylon internal caches flushed');
    }
  } catch (err) {
    console.warn('[babylon-cache] Babylon cache cleanup skipped:', err);
  }

  console.log('[babylon-cache] ✅ All caches cleared');
}

// expose a tiny debug API for DevTools
declare global { interface Window { __BABYLON_CACHE__?: any } }

(function exposeGlobal() {
  const api = {
    // include whatever you want to call from DevTools:
    writeMeta,
    clearAllCaches,
    // optional:
    // getAsset,
    // clear: clearCache,  // if we kept the earlier clear()
  };
  (window as any).__BABYLON_CACHE__ = {
    ...(window as any).__BABYLON_CACHE__,
    ...api,
  };
}());

// -----------------------------------------------------------------------------------------------
// --- Safe reload of REACT applications, i hope -----------------------------------------------
// ------------------------------------------------------------------------------------------------
export function reloadOnce(key: string, ttlMs = 15_000) {
  try {
    const storageKey = `__sw_reload_once__:${key}`;
    const now = Date.now();
    const raw = sessionStorage.getItem(storageKey);

    if (raw) {
      const ts = Number(raw) || 0;
      // If the last reload was very recent, skip to avoid loops
      if (now - ts < ttlMs) return false;
    }

    sessionStorage.setItem(storageKey, String(now));
    location.reload();
    return true; // we’ll reload immediately
  } catch {
    // Fallback: if sessionStorage isn’t available, still reload
    location.reload();
    return true;
  }
}
// -----------------------------------------------------------------------------------------------
// --- Cache initialization, to be called as early as possible, index.tsx
// ------------------------------------------------------------------------------------------------
let initialized = false;

// prevent duplicate message listeners across HMR/re-mounts
const MSG_FLAG = '__babylon_cache_sw_msg_listener__' as const;

export type InitAssetCachingOptions = {
  swUrl?: string; // e.g. new URL("sw.js", location.href).toString() + ?v=...
  scope?: string; // defaults to current directory: new URL(".", location.href).pathname
  reloadOnActivate?: boolean; // reload once when SW first activates (default true)
  sameOriginOnly?: boolean; // ignore cross-origin assets when mirroring to IndexedDB (default true)
};

export function initAssetCaching(opts: InitAssetCachingOptions = {}) {
  if (initialized) return;
  initialized = true;

  if (!('serviceWorker' in navigator) || !window.isSecureContext) {
    console.warn('[babylon-cache] SW not available (needs HTTPS/localhost).');
    return;
  }

  const swUrl = opts.swUrl ?? new URL('sw.js', location.href).toString();
  const scope = opts.scope ?? new URL('.', location.href).pathname;
  const reloadOnActivate = opts.reloadOnActivate ?? true;
  const sameOriginOnly = opts.sameOriginOnly ?? true;

  navigator.serviceWorker
    .register(swUrl, { scope })
    .then((reg) => {
      console.log('[sw] registered:', swUrl, 'scope:', scope);

      // Reload once so the *current page* comes under SW control
      if (reloadOnActivate && !navigator.serviceWorker.controller) {
        const sw = reg.installing || reg.waiting || reg.active;
        if (sw) {
          const maybeReload = () => {
            if (sw.state === 'activated' && !navigator.serviceWorker.controller) {
              // Ensure we only ever do this once per page
              reloadOnce(`enable:${scope}`);
            }
          };
          sw.addEventListener('statechange', maybeReload);
          // in case it's already activated
          maybeReload();
        } else {
          // Fallback: if controller becomes available later, reload once
          const onController = () => {
            navigator.serviceWorker.removeEventListener('controllerchange', onController);
            if (!document.hidden) location.reload();
          };
          navigator.serviceWorker.addEventListener('controllerchange', onController);
        }
      }
    })
    .catch((e) => console.error('[sw] register failed:', e));

  // Add the ASSET_CACHED mirror to IndexedDB only once
  if (!(window as any)[MSG_FLAG]) {
    (window as any)[MSG_FLAG] = true;

    navigator.serviceWorker.addEventListener('message', async (ev: MessageEvent) => {
      const d: any = ev.data;
      if (!d || d.type !== 'ASSET_CACHED') return;

      const { url, size, ts } = d as { url: string; size: number; ts: number };

      if (sameOriginOnly) {
        try {
          const u = new URL(url, location.href);
          if (u.origin !== location.origin) return;
        } catch {
          return;
        }
      }

      const isText = /\.(?:gltf|json|svg)$/i.test(url);
      const ttlMs = isText ? 0 : 365 * 24 * 3600 * 1000;

      try {
        await writeMeta({
          url,
          size: Number(size) || 0,
          lastAccess: Number(ts) || Date.now(),
          ttlMs,
          pinned: false,
        });
      } catch {
        // ignore write failures
      }
    });
  }
}

// -----------------------------------------------------------------------------------------------
// --- Cache service killer, to be called as early as possible, index.tsx
// ------------------------------------------------------------------------------------------------
type StopAssetCachingOptions = {
  swUrl?: string; // e.g. new URL("sw.js", location.href).toString()
  scope?: string; // defaults to current directory: new URL('.', location.href).pathname
  reload?: boolean; // default true: reload after unregister so page is uncontrolled -> dangerous
  clearCaches?: boolean | string | RegExp; // false=none (default). true=all. string=prefix. RegExp=match.
};

export async function stopAssetCaching(opts: StopAssetCachingOptions = {}) {
  const reload = opts.reload ?? true;

  // SW must be available (same condition as init)
  if (!('serviceWorker' in navigator) || !window.isSecureContext) {
    console.warn('[babylon-cache] SW not available (needs HTTPS/localhost).');
    return { unregistered: 0, clearedCaches: 0 };
  }

  // Resolve defaults the same way initAssetCaching does
  const swUrl = opts.swUrl ?? new URL('sw.js', location.href).toString();
  const scopePath = opts.scope ?? new URL('.', location.href).pathname;

  const targetPath = new URL(swUrl, location.href).pathname; // ignore ?v=...
  const expectedScopeHref = new URL(scopePath, location.origin).href;

  // Find matching registrations
  const regs = await navigator.serviceWorker.getRegistrations();

  const matchesByPathAndScope = regs.filter((r) => {
    const scriptURL = r.installing?.scriptURL || r.waiting?.scriptURL || r.active?.scriptURL;
    if (!scriptURL) return false;
    const u = new URL(scriptURL);
    return u.pathname === targetPath && r.scope === expectedScopeHref;
  });

  // Fallback: if none matched by scope, match any scope (still same /sw.js)
  const matches = matchesByPathAndScope.length > 0
    ? matchesByPathAndScope
    : regs.filter((r) => {
      const scriptURL = r.installing?.scriptURL || r.waiting?.scriptURL || r.active?.scriptURL;
      if (!scriptURL) return false;
      const u = new URL(scriptURL);
      return u.pathname === targetPath;
    });

  const unregResults = await Promise.all(matches.map((r) => r.unregister()));
  const unregistered = unregResults.filter(Boolean).length;

  // Optionally clear caches created by the SW
  let clearedCaches = 0;
  if (typeof caches !== 'undefined' && opts.clearCaches) {
    const keys = await caches.keys();
    const shouldDelete = (name: string) => {
      if (opts.clearCaches === true) return true;
      if (typeof opts.clearCaches === 'string') return name.startsWith(opts.clearCaches);
      if (opts.clearCaches instanceof RegExp) return opts.clearCaches.test(name);
      return false;
    };
    await Promise.all(
      keys.map(async (k) => {
        if (shouldDelete(k)) {
          const ok = await caches.delete(k);
          if (ok) clearedCaches++;
        }
      }),
    );
  }

  // Let initAssetCaching re-add its message listener next time
  try {
    // Keep the same flag name you used above
    (window as any).__babylon_cache_sw_msg_listener__ = undefined;
    delete (window as any).__babylon_cache_sw_msg_listener__;
  } catch {}

  // Important: even after unregister, the current page stays controlled until reload
  if (reload) {
    reloadOnce(`disable:${opts.scope ?? new URL('.', location.href).pathname}`);
  }

  return { unregistered, clearedCaches };
}
